<template>
  <div class="analysis_warp">
    <div class="top">
      <img src="@/static/topCard/CaretCircleLeft.png"
           @click="back"
           alt="">
      <div style="margin-left: 42%;">我的试卷</div>
    </div>
    <div class="middle">

      <a-select v-model:value="form.subject_id"
                placeholder="请选择"
                @change="checkStatus()">
        <a-select-option v-for="item in subjectList"
                         :key="item.subject_id"
                         :value="item.subject_id">
          {{item.subject_name}}
        </a-select-option>
      </a-select>
      <a-select v-model:value="form.status"
                placeholder="请选择"
                @change="checkStatus()">
        <a-select-option v-for="item in statusList"
                         :key="item.id"
                         :value="item.id">
          {{item.label}}
        </a-select-option>
      </a-select>
      <div class="sort"
           @click="sortChange">
        时间排序<img> <img v-if="sort == 'ASC'"
             src="@/static/sort1.png"
             alt="">
        <img v-else
             src="@/static/sort.png"
             alt="">
      </div>
    </div>
    <div v-if="tableData.length >0" class="list">
      <!-- 我的试卷 未批改试卷 已批改试卷 列表 -->
      <div class="warp"
           v-if="form.status < 5">
        <div v-for="(row,index) in tableData"
             :key="index"
             class="paper_list">
          <div class="paper_img">
            <div style="font-size: 20rem;font-weight:400;line-height:30rem;color: #999;">
              <!-- 总分：{{row.paper_score}} -->
              {{row.paper_time}}
            </div>
            <div class="img"><img src="@/static/mypaper.png"
                   alt=""></div>
          </div>
          <div class="paper_title">

            <div>
              <span class="overflow-hidden"
                    style="font-size: 28rem;font-weight: 600;line-height: 42rem;">{{row.subject_name}}</span>
            </div>

          </div>
          <div class="paper_score">
            <div v-if="correctFinishedCanShow(row)"
                 style="display: flex;gap: 32rem;">
              <!-- <div><span>排名：</span><span style="color:#FB9930">{{row.rank}}</span></div> -->
              <!-- <div v-if="parseFloat(row.user_score) != 0"><span style="color: #666;">打败了{{row.percent}}%人</span></div> -->
            </div>
            <div><span>我的得分：</span><span style="color:#F2413A;font-weight:600;">{{row.user_score}}</span></div>
            <div><span>总分：</span><span style="color:#333;font-weight:600;">{{row.paper_score}}</span></div>
            <!-- <div v-if="correctFinishedCanShow(row)"><span>平均得分：</span><span style="color:#333;font-weight:600;">{{row.avg_score}}</span></div>
            <div style="display: flex;flex-wrap: wrap;align-self: stretch;">
              <span style="color: #999;">总评：</span>
              <span class="overflow-hidden"
                    style="flex: 1 0 0;color:#333">
                <label v-if="row.paper_comment && row.paper_comment.length > 18"
                       @click="showCommentDetail(row)"
                       style="color: #2196f3; float: right;clear: both;line-height: 36rem;cursor: pointer;">查看全部</label>
                {{row.paper_comment?row.paper_comment:'无'}}
              </span>
            </div> -->
          </div>
          <!-- <div :class="{'desc':true,'check':row.correct_type == 2 && selfCorrectStatus.indexOf(row.judge_status) != -1}">
                {{getValue(row)}}
              </div> -->
          <div :class="correctFinished.indexOf(row.judge_status) != -1 ? 'correct-info' : 'correct-danger'">
            <span>{{getValue(row)}}</span>
          </div>
          <div>
            <div class="paper_btn"
                 style="background: #f2413a;"
                 @click="doPaper(row)"
                 v-if="row.judge_status == 0">
              <!-- 自评状态  且 未批改 -->
              继续做卷
            </div>
            <div class="paper_btn"
                 style="background: #2196f3;"
                 @click="toAnalysis(row)"
                 v-else>
              答案解析
            </div>
          </div>
        </div>
      </div>

      <!-- 未完成试卷列表 -->
      <div class="warp"
           v-else>
        <div v-for="(row,index) in tableData"
             class="paper_list"
             :key="index">
          <div>
              <div style="font-size: 20rem;font-weight:400;line-height:30rem;color: #999;margin-left: 12rem;">
              <!-- 总分：{{row.paper_score}} -->
              {{row.paper_time}}
            </div>
            <div class="paper_name">
              
              <div class="img">
                
                <img src="@/static/underpaper.png"
                     alt="">
              </div>
              <div class="text">
                <div>
                  {{row.subject_name}}
                </div>
                <!-- <div>
                  <span>
                    试卷ID:</span>
                  <span>
                    {{row.user_paper_id}}
                  </span>
                </div>
                <div>
                  做卷时间：{{row.paper_time}}
                </div>
                <div>
                  试卷描述：{{row.paper_desc}}
                </div> -->
              </div>
            </div>
          </div>
          <div class="paper_score">
            <div v-if="correctFinishedCanShow(row)"
                 style="display: flex;gap: 32rem;">
              <!-- <div><span>排名：</span><span style="color:#FB9930">{{row.rank}}</span></div> -->
              <!-- <div v-if="parseFloat(row.user_score) != 0"><span style="color: #666;">打败了{{row.percent}}%人</span></div> -->
            </div>
            <div><span>我的得分：</span><span style="color:#F2413A;font-weight:600;">{{"-"}}</span></div>
            <div><span>总分：</span><span style="color:#333;font-weight:600;">{{row.paper_score}}</span></div>
            <!-- <div v-if="correctFinishedCanShow(row)"><span>平均得分：</span><span style="color:#333;font-weight:600;">{{row.avg_score}}</span></div>
            <div style="display: flex;flex-wrap: wrap;align-self: stretch;">
              <span style="color: #999;">总评：</span>
              <span class="overflow-hidden"
                    style="flex: 1 0 0;color:#333">
                <label v-if="row.paper_comment && row.paper_comment.length > 18"
                       @click="showCommentDetail(row)"
                       style="color: #2196f3; float: right;clear: both;line-height: 36rem;cursor: pointer;">查看全部</label>
                {{row.paper_comment?row.paper_comment:'-'}}
              </span>
            </div> -->
          </div>
          <!-- <div :class="{'desc':true,'check':row.correct_type == 2 && selfCorrectStatus.indexOf(row.judge_status) != -1}">
                {{getValue(row)}}
              </div> -->
          <div :class=" 'correct-info' ">
            <span>{{getValue(row)}}</span>
          </div>

          <div>
            <div class="btn_warp">
              <div class="btn"
                   @click="doPaper(row)">
                继续做卷
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="list1"
         v-else>
      <div><img src="@/static/rank/nodata.png"
             alt=""
             class="img" /></div>
      <div class="text2">暂无做卷数据 </div>
    </div>
  </div>

</template>

 
<script setup>

import { getUserSubject } from '@/api/subject.js'
import { addPost } from '@/api/post.js'
import { nextTick, onMounted, ref, reactive, onUnmounted } from 'vue'
import { getSkbSubject, skbUserPaper } from '@/api/quick.js'

import { message } from 'ant-design-vue'
import { useRoute, useRouter } from "vue-router";

const router = useRouter()
let statusList = ref([
  { id: 0, label: '全部试卷' },
  // { id: 1, label: '未批改试卷' },
  { id: 3, label: '已批改试卷' },
  { id: 5, label: '未完成试卷' },
])

let selfCorrectStatus = ref([101, 1, 102, 2, 103, 3, 10, 7, 107, 0])
let correctFinished = ref([4, 104, 105, 106])
let route = useRoute()
let showWindow = ref(false)
let mapRef = ref()
let subject_id = ref('')
let userinfo = ref(null)
let ScoreRef = ref(null)
let userId = ref('')
let subjectIndex = ref(0)
let subjectList = ref([])
let tableData = ref([])
let activeIndex = ref(null)
let form = reactive({
  subject_id: 0,
  status: 0
})
let sort = ref("ASC")
const getSubjectList = async () => {
  const { data } = await getSkbSubject()
  subjectList.value = data.list
  subjectList.value.unshift({ subject_id: 0, subject_name: '全部科目' })

}
const toAnalysis = (row) => {
  router.push('/analysis1?user_paper_id=' + row.user_paper_id)
}
const checkStatus = (index) => {

  initList()

}
const sortChange = (e) => {
  if (sort.value == "ASC") {
    sort.value = "DESC"
  } else {
    sort.value = "ASC"
  }
  initList()
}
// 点击继续做卷
const doPaper = (row) => {
  window.sessionStorage.removeItem('images')
  window.sessionStorage.removeItem('testpaperCardIndex')
  window.sessionStorage.removeItem('paper')
  router.push(`/doPaper1?user_paper_id=${row.user_paper_id}&flag=1`)
}
const correctFinishedCanShow = (row) => {
  return (correctFinished.value.indexOf(row.judge_status) != -1 && row.famous_paper_source != 0)
}
const getValue = (item) => {
  // if (item.judge_status == 1 || item.judge_status == -1) {
  //   return '未批改'
  // }
  if (item.judge_status == 2 || item.judge_status == 3) {
    return '正在批改'
  }
  if (item.judge_status == 0) {
    return '试卷未完成'
  }
  let overArr = [4, 5, 6, 105]
  if (overArr.indexOf(item.judge_status) != -1) {
    return '试卷已完成'
  }
}
const initList = async (id) => {
  tableData.value = []
  console.log(form)
  let params = {
    subject_id: form.subject_id,
    status: form.status,
    order: sort.value,
  }
  const { data } = await skbUserPaper(params)
  tableData.value = [...tableData.value, ...data.list]
}

onMounted(() => {
  // getSubject()
  userinfo.value = JSON.parse(window.localStorage.getItem('userInfo'))
  userId.value = Number(userinfo.value.user_id)
  nextTick(() => {

  })
  getSubjectList()
  initList()
})


const back = () => {
  router.push("/quick")

}
onUnmounted(() => {

})




</script>
 
<style lang="scss" scoped>
.analysis_warp {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #f6f6f6;
  ::v-deep .ant-select-selector {
    display: flex;
    width: 320rem;
    height: 48rem;
    padding: 0 var(--Spacing-M, 24rem);
    align-items: center;
    gap: 8rem;
    border-radius: var(--Radius-MAX, 100rem);
    border: 1rem solid var(--light-cccccc, #ccc);
    background: #fff;
    color: var(--light-333333, #333);

    font-size: 20rem;
    font-style: normal;
    font-weight: 400;
    line-height: 30rem; /* 150% */
  }
  .top {
    width: 1856rem;
    margin-top: 40rem;

    align-items: center;
    gap: 10rem;
    margin-left: 32rem;
    display: flex;
    border-radius: 32rem;
    background: #fff;
    height: 80rem;
    padding: 0 24rem;
    // justify-content: center;
    color: var(--light-333333, #333);
    text-align: center;

    font-size: 28rem;
    font-style: normal;
    font-weight: 600;
    line-height: 42rem; /* 150% */
    img {
      width: 48rem;
      height: 48rem;
    }
  }
  .list {
    width: 100%;
    // max-height: calc(100vh - 60rem - 40rem);
    height: 75%;
    -ms-overflow-style: none;
    background: white;
    overflow-y: auto;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    .div {
      padding: 10rem;
      border-bottom: 1rem solid #f1f1f1;
      display: flex;
      align-items: center;
      &:hover {
        background: rgba($color: #2196f3, $alpha: 0.1);
      }
    }
    // div {
    //   height: 80rem;
    //   line-height: 80rem;
    // }
    .paper_list {
      .img {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 240rem;
        height: 160rem;
        background: #6cb9f5;
        border-radius: 16rem;
        flex-shrink: 0;
        img {
          width: 48rem;
          height: 48rem;
        }
      }
      .paper_name {
        // margin-left: 50rem;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        // height: 110rem;
        padding: 10rem;
        .text {
          min-height: 70rem;
          margin-left: 20rem;
          div {
            width: 600rem;
            &:nth-child(1) {
              font-size: 20rem;
              font-weight: bold;
              color: #000000;
            }
            &:nth-child(2) {
              margin-top: 10rem;
              font-size: 20rem;
              font-weight: bold;
              color: #000000;
              // line-height: 20rem;
            }
            &:nth-child(3) {
              margin-top: 10rem;
              font-weight: 500;
              font-size: 20rem;
              color: #333333;
              display: flex;
              flex-wrap: wrap;
              word-wrap: break-word;
              span {
                &:nth-child(1) {
                  width: 100rem;
                }
                &:nth-child(2) {
                  width: calc(100% - 200rem);
                }
              }
            }
            &:nth-child(4) {
              margin-top: 10rem;
              font-weight: 500;
              font-size: 20rem;
              color: #333333;
              display: flex;
              flex-wrap: wrap;
              word-wrap: break-word;
              span {
                &:nth-child(1) {
                  width: 100rem;
                }
                &:nth-child(2) {
                  width: calc(100% - 200rem);
                }
              }
            }
          }
        }
      }
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: flex-start;
      align-items: center;
      padding: 24rem 40rem;
      max-height: 296rem;
      border-bottom: 1rem solid #eee;
      gap: 40rem;
      &:hover {
        background: rgba($color: #2196f3, $alpha: 0.1);
      }
      .paper_img {
        display: flex;
        gap: 8rem;
        flex-direction: column;
        .img {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 240rem;
          height: 160rem;
          background: #6cb9f5;
          border-radius: 16rem;
          flex-shrink: 0;
          img {
            width: 48rem;
            height: 48rem;
          }
        }
      }
      .paper_title {
        width: 538rem;
        display: flex;
        gap: 8rem;
        flex-direction: column;
        margin-top: -76rem;
      }
      .paper_score {
        width: 400rem;
        display: flex;
        gap: 8rem;
        flex-direction: column;
        font-size: 24rem;
        font-weight: 400;
        line-height: 36rem;
        color: #999;
      }
      .correct-danger {
        width: 320rem;
        border-radius: 16rem;
        padding: 8rem 16rem;
        background-color: rgba(244, 65, 58, 0.1);
        span {
          font-size: 28rem;
          font-weight: 400;
          line-height: 42rem;
          color: #f2413a;
        }
      }
      .correct-info {
        width: 320rem;
        border-radius: 16rem;
        padding: 8rem 16rem;
        background-color: rgba(51, 51, 51, 0.1);
        span {
          font-size: 28rem;
          font-weight: 400;
          line-height: 42rem;
          color: #333;
        }
      }
      .paper_btn {
        cursor: pointer;
        // width: 96rem;
        border-radius: 8rem;
        padding: 8rem 28rem;
        font-size: 24rem;
        font-weight: 400;
        line-height: 36rem;
        align-items: center;
        color: #fff;
      }
    }

    .score {
      font-weight: 500;
      color: #333333;
      font-size: 20rem;
      // height: 110rem;
      display: flex;
      align-items: center;
      margin-left: 30rem;
    }
    .btn_warp {
      display: flex;
      // height: 110rem;
      align-items: center;
      justify-content: flex-end;
      .btn {
        margin-right: 20rem;
        width: 120rem;
        height: 44rem;
        background: #2196f3;
        border-radius: 5rem;
        font-size: 20rem;
        font-weight: bold;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
    }
  }
    .list1{
  
    &::-webkit-scrollbar {
      width: 0 !important;
    }
      width: 100%;
  overflow: hidden;
color: var(--light-999999, #999);
text-overflow: ellipsis;
 
font-size: 24rem;
font-style: normal;
font-weight: 400;
line-height: 36rem; /* 150% */
    justify-content: center;
    display: flex;
    align-items: center;
    height: 79%;
    flex-direction: column;
  }
  .middle {
    display: flex;
    padding: 26rem 40rem;
    align-items: flex-start;
    gap: 24rem;
    .sort {
      display: flex;
      font-size: 20rem;
      color: #000;
      font-style: normal;
      font-weight: 400;
      line-height: 30rem; /* 150% */
      // width: 160rem;
      height: 48rem;
      padding: 0 var(--Spacing-M, 24rem);
      justify-content: flex-end;
      align-items: center;
      gap: 8rem;
      border-radius: var(--Radius-MAX, 100rem);
      border: 1rem solid var(--light-cccccc, #ccc);
      background: #fff;
    }
  }
  .content {
    height: 682rem;
    border-radius: 32rem;
    background: #fff;
  }
}
.fixed_btn {
  position: fixed;
  top: 50rem;
  right: 30rem;
  font-size: 24rem;
  display: flex;
  // width: 350rem;
  div {
    // flex: 1;
    text-align: center;
  }
  img {
    width: 36rem;
    height: 36rem;
    margin-left: 30rem;
  }
}
</style>